/* istanbul ignore file */
import { SET_CATEGORY_TRANSACTIONS } from './actionTypes'

export const setCategoryTransactions = items => {
  return {
    type: SET_CATEGORY_TRANSACTIONS,
    items
  }
}
